export class FardeSearchParams {
  svcIds?: number[];
  classementIds?: number[];
  text?: string;
  fardeId?: number;
  chemiseId?: number;
  archived: boolean;
}
